<script>
export default {
  name: 'SlideModal',
  components: {},
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    button: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      isActive: false,
    }
  },
  computed: {

  },
  created() {},
  methods: {
    showModal() {
      this.isActive = true
    },
    hideModal() {
      this.isActive = false
      this.$emit('closeModal')
    }
  }
}
</script>

<template>
  <div :class="$style.modalFixed">
    <transition name="minimun">
      <div
        v-if="active"
        :class="$style.modal">
        <div :class="$style.modalWrapper">
          <div :class="$style.modalHead">
            <h3>
              {{ title }}
            </h3>
          </div>
          <div :class="$style.modalBody">
            {{ body }}
          </div>
        </div>
        <BaseButton
          :class="$style.button"
          @click="hideModal"
        >
          {{ button }}
        </BaseButton>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped module>
@import '@design';

.modalFixed {
  position: fixed;
  display: flex;
  top: 0;
  height: 100vh;
  background: rgba(0, 0 ,0 ,.7);
  z-index: 99999;
  // stylelint-disable-next-line selector-class-pattern
  &:global(.fade-leave-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.fade-leave-to) {
    opacity: 0;
  }
}

.modal {
  background: $white;
  padding-bottom: 40px;
  margin-top: auto;
  border-radius: 10px 10px 0 0;
  // stylelint-disable-next-line selector-class-pattern
  &:global(.minimun-leave-active) {
    transition: max-height .5s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.minimun-leave-to) {
    max-height: 0;
    overflow: hidden;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.minimun-enter-active) {
    transition: max-height .5s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.minimun-enter) {
    max-height: 0;
    overflow: hidden;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.minimun-enter-to) {
    max-height: 400px;
    overflow: hidden;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.minimun-leave) {
    max-height: 400px;
    overflow: hidden;
  }
}

.modalWrapper {
  width: 100vw;
  padding: 2rem;
}

.modalHead {
  font-size: 1.8rem;
  font-weight: bold;
  padding-bottom: 2rem;
  color: $color-heading-text;
}

.modalBody {
  font-size: $size-spacing-medium;
  color: $darker-gray;
  letter-spacing: 1px;
  text-align: left;
}

.button {
  width: 95%;
}

.closeModal {
  position: relative;
  top: 12px;
  left: 12px;
}
</style>
